import React, { useEffect, useState } from 'react';
import './AllForInvite.scss';
import { IComponentInviteUser } from '../../component';
import useTheme from '../hooks/useTheme';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import {style} from '../../utils/image';
import {alpha, getPendantColor} from '../../utils/color';
import intl from 'react-intl-universal';
import BottomModal from '../ButtonGroup/BottomModal';
import {ShareModal, ShareQrcode} from '../ComponentPendantV2/ShareButton';

const TOP_ICON = {
  '1':require('../../assets/invite_top1.png'),
  '2':require('../../assets/invite_top2.png'),
  '3':require('../../assets/invite_top3.png'),
} as {
  [key: string]: any;
};

interface IAllForInvite extends IComponentInviteUser {
  rootStore?: RootStore;
}

interface IInviteList {
  data: IInviteItem[];
  total: number;
  page: number;
  setPage: (p: number) => void;
  onShowMore?: () => void;
  useLoadMore?: boolean;
  onInvite?: () => void;
  topx: number;
}

interface IInviteItem {
  number: number;
  nickname: string;
  photo: string;
  openid: string;
  isMe?: boolean;
  rate: number | string;
  onInvite?: () => void;
}

const getOpenIdAfter = (str:string, len:number = 4)=>{
  return (str || "").substr(-4).toUpperCase();
};

const getItemUserInfo = (item:any)=>{
  if(item && item.shareuser_detail) {
    return {
      nickname:item.shareuser_detail.nickname,
      photo:item.shareuser_detail.photo,
      number:item.invite_sum,
      openid:item.share_user,
      rate:item.rate,
    } as IInviteItem;
  }
  return {
    number:item.invite_sum,
    nickname:'网友' + getOpenIdAfter(item.share_user),
    photo:require('../../assets/avatar-4.png'),
    openid:item.share_user,
    rate:item.rate
  } as IInviteItem;
}

const InviteList = (props:IInviteList)=>{
  const {data, topx, total, page, setPage, onShowMore, useLoadMore, onInvite} = props;
  const top3 = data && data.length ? data.slice(0, 3) : [];
  const other = data && data.length ? data.slice(3) : [];
  const theme = useTheme();

  let meIndex = -1;
  let me = data && data.length ? data.find((it:any)=>{
    return it && it.share_user == window.userinfo.openid;
  }) : null;

  if(me) {
    me = getItemUserInfo(me);
  }else {
    me = {
      nickname:window.userinfo.nickname || '网友' + getOpenIdAfter(window.userinfo.openid),
      photo:window.userinfo.photo || require('../../assets/avatar-4.png'),
      number:0,
      openid:window.userinfo.openid,
      rate:'--'
    } as IInviteItem;
  }

  const [loading, setLoading] = useState(false);
  const renderLoadMore = ()=>{
    if(useLoadMore) {
      if(data && data.length >= total) {
        return null;
      }
      if(loading) {
        return <div className="loadMore" style={{color:theme.h2Color}}>加载中</div>
      }
      return <div className="loadMore" style={{color:theme.h2Color}}>
        查看更多
      </div>;
    }
  };

  useEffect(()=>{
    if(data && data.length) {
      setLoading(false);
    }
  }, [data]);

  useEffect(()=>{
    const dom = window.document.querySelector('.invite-modal');
    const parentNode = dom ? dom.parentNode : null;

    const onScroll = (e:any)=>{
      // @ts-ignore
      if(parentNode && (parentNode.scrollTop + parentNode.clientHeight + 50) >= parentNode.scrollHeight) {
        setLoading(true);
        setPage(page + 1);
      }
    };

    if(parentNode && data && data.length < total && !loading) {
      parentNode.addEventListener('scroll', onScroll, false);
    }

    return ()=>{
      if(parentNode) {
        parentNode.removeEventListener('scroll', onScroll);
      }
    }
  }, [data, loading]);

  useEffect(()=>{
    if(useLoadMore) {
      setLoading(true);
      setPage(page + 1);
    }
  }, [useLoadMore]);

  return <div className="invite-list">
    <InviteTopx data={top3} />
    {!useLoadMore ? <InviteItem {...me} isMe={true} onInvite={onInvite} /> : null}
    {other && other.length ? other.map((it: IInviteItem, i: number)=>{
      let item = getItemUserInfo(it);
      return <InviteItem {...item} key={item.openid + `` + i} />;
    }) : null}
    {total > topx && !useLoadMore ? <div className="showmore" onClick={onShowMore} style={{backgroundColor:theme.mainColor, color:alpha(theme.componentColor, 1)}}>
      {intl.get('ShowMore')}
    </div> : null}
    {renderLoadMore()}
  </div>;
};

const InviteItem = (props:IInviteItem)=>{
  const {photo, rate, nickname, number, isMe, onInvite} = props;
  const theme = useTheme();

  return <div className={`invite-item ${isMe ? 'border' :''}`} style={{borderColor:alpha(theme.h2Color, 0.1)}}>
    <div className="rate" style={{color:theme.h1Color}}>{rate}</div>
    <div className="userinfo">
      <img className="avatar" src={photo} />
      <div className="nickname" style={{color:theme.h1Color}}>{nickname}</div>
      {isMe ? <div className="isme">{intl.get('Me')}</div> : null}
    </div>
    <div className="invite">
      <div className="number" style={{color:theme.h2Color}}>{intl.get('Invited', {n1:number})}</div>
      {isMe ? <div onClick={onInvite} className="share" style={{backgroundColor:theme.mainColor, color:alpha(theme.componentColor, 1)}}>{intl.get('ToInvite')}</div> : null}
    </div>
  </div>
};

const InviteTopx = (props:{
  data:IInviteItem[]
})=>{
  const {data} = props;
  const [top1, top2, top3] = data;
  const theme = useTheme();

  const TopX = (props:any)=>{
    const {item, rate} = props;
    const userinfo = getItemUserInfo(item);

    return <div className={`invite-top-item top${rate}`}>
      <div className="avatar">
        <img src={TOP_ICON[String(rate)]} className="rate" />
        <img src={userinfo.photo} className="photo" />
      </div>
      <div className="invite-top-item-wrapper">
        <div className="nickname" style={{color:alpha(theme.componentColor, 1)}}>{userinfo.nickname}</div>
        <div className="number" style={{color:alpha(theme.componentColor, 1)}}>{intl.get('Invited', {
          n1:userinfo.number
        })}</div>
      </div>
    </div>;
  }

  return <div className="invite-top3">
    {top2 ? <TopX item={top2} rate={2} /> : <div className="invite-top-item"></div>}
    {top1 ? <TopX item={top1} rate={1} /> : <div className="invite-top-item"></div>}
    {top3 ? <TopX item={top3} rate={3} /> : <div className="invite-top-item"></div>}
  </div>
};

const AllForInvite = (props: IAllForInvite)=>{
  const { topx, rootStore } = props;
  const {wxuserStore, uiStore} = rootStore!;

  const [page, setPage] = useState(1);
  const loadPage = ()=>{
    return wxuserStore.getInviteUserList(page, topx);
  };

  useEffect(()=>{
    loadPage();
  }, [page]);

  const {data, total} = wxuserStore.inviteUserList;
  const [showDetail, setShowDetail] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showQrcode, setShowQrcode] = useState(false);

  const getTopxList = ()=>{
    if(data && data.length) {
      return data.slice(0, topx);
    }

    return data;
  };

  return (<>
    <div className={'all-for-invite'}>
      <div className="row-wrapper">
        <InviteList data={getTopxList()} topx={topx} total={total} page={page} setPage={setPage} onShowMore={()=>{
          setShowDetail(true);
        }} onInvite={()=>{
          if (wxuserStore.user.is_mock) {
            wxuserStore.auth();
            return false;
          }
          setShowModal(true);
        }} />
      </div>
    </div>
    {showDetail ? <BottomModal
      title={'榜单'}
      show={showDetail}
      onHide={() => setShowDetail(false)}
      child={<div className="invite-modal" style={{margin:`10px`}}>
        <InviteList data={data} topx={topx} total={total} page={page} setPage={setPage} useLoadMore={true} />
      </div>
      }
    /> : null}
    {showModal ? <ShareModal showModal={showModal} isFold={false} onQrcodeClick={() => {
      setShowQrcode(true);
      setShowModal(false);
    }} onLinkClick={() => {
      uiStore.showToast({
        content: intl.get('Copyed')
      });
      setShowModal(false);
    }} onClose={() => setShowModal(false)} /> : null}
    {showQrcode ? (
      <ShareQrcode
        onClose={() => {
          setShowQrcode(false);
        }}
        isFold={false}
      />
    ) : null}
  </>);
};

export default inject('rootStore')(observer(AllForInvite));
